import React, { useState, useEffect, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import {
  formatMoneda,
  validaSoloNumero,
  validaMonto,
  formatoMonto,
} from "../../util/varios";
import { TableBody, TableRow, TableCell } from "@material-ui/core";

import moment from "moment";
import * as XLSX from "xlsx";
import useTableScroll from "../useTableScroll";

const IncluirProductosExcel = () => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  //const anio = JSON.parse(sessionStorage.getItem("anioactu"));
  //const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));

  const chkSi = useRef();
  const chkNo = useRef();

  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [habilitado, setHabilitado] = useState(true);
  const [insertProduct, setInsertProduct] = useState([]);
  const [updateProduct, setUpdateProduct] = useState([]);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoper: true,
  });

  const [headCells, setHeadCells] = useState([]);
  const { TblContainer, TblHead } = useTableScroll(headCells);

  const blanquear = () => {
    chkSi.current.checked = false;
    chkNo.current.checked = false;
    setVisibleBtn("visible");
    setActivate(false);
    setHabilitado(true);
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      catalogoper: true,
    });
  };

  const procesarRegistro = (operacion, body) => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/cerveceria/actualizar/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setInsertProduct([]);
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: `${response.data.contar} registro creado correctamente`,
              icono: "exito",
            });
          } else if (operacion === 2) {
            setUpdateProduct([]);
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: `${response.data.contar} registro modificado correctamente`,
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: `${response.data.contar} registro eliminado correctamente`,
              icono: "exito",
            });
          }

          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistros = (productFile) => {
    let campos = "codigo";
    let nomtab = "producto";
    let orden = "idproducto";
    const datos = [];

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            for (let index = 0; index < response.data.length; index++) {
              datos.push(response.data[index].codigo);
            }
            procesarPrecioProd(datos, productFile);
          } else {
            setInsertProduct(productFile);
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const calcularUtilidadxValor = (producto) => {
    let iva = producto[5];
    let costo = producto[6];
    let venta = producto[8];

    let mon = (costo * iva) / 100;
    mon = mon + costo;
    let mon3 = 0.0;

    mon3 = (venta - mon) / mon;
    mon3 = mon3 * 100;
    return mon3;
  };

  const calcularUtilidadxValorAlter = (producto) => {
    let iva = producto[5];
    let costo = producto[4];
    let venta = producto[7];

    let mon = (costo * iva) / 100;
    mon = mon + costo;
    let mon3 = 0.0;

    mon3 = (venta - mon) / mon;
    mon3 = mon3 * 100;
    return mon3;
  };

  const updateProcess = () => {
    let productos = [];
    for (let i = 0; i < updateProduct.length; i++) {
      productos.push({
        codigo: updateProduct[i][1],
        nombre: updateProduct[i][2],
        nombrecorto: updateProduct[i][2],
        ivacompra: updateProduct[i][5],
        ivaventa: updateProduct[i][9],
        exento: parseFloat(updateProduct[i][9]) > 0.0 ? false : true,
        valorfactor: updateProduct[i][3],
        tipofactor: parseInt(updateProduct[i][3]) > 1 ? 1 : 0,
        costoproveedor: updateProduct[i][6],
        costocalculado: updateProduct[i][6],
        ultimocosto: updateProduct[i][6],
        costopromedio: updateProduct[i][6],
        costoproveedoralter: updateProduct[i][4],
        costocalculadoalter: updateProduct[i][4],
        ultimocostoalter: updateProduct[i][4],
        costopromedioalter: updateProduct[i][4],
        utipreciomaxi: calcularUtilidadxValor(updateProduct[i]),
        utiprecioofe: calcularUtilidadxValor(updateProduct[i]),
        utipreciomayor: calcularUtilidadxValor(updateProduct[i]),
        utipreciomini: calcularUtilidadxValor(updateProduct[i]),
        utipreciomaxialter: calcularUtilidadxValorAlter(updateProduct[i]),
        utiprecioofealter: calcularUtilidadxValorAlter(updateProduct[i]),
        utipreciomayoralter: calcularUtilidadxValorAlter(updateProduct[i]),
        utipreciominialter: calcularUtilidadxValorAlter(updateProduct[i]),
      });
    }
    procesarRegistro(2, { productos: JSON.stringify(productos) });
  };

  const insertProcess = () => {
    let productos = [];
    for (let i = 0; i < insertProduct.length; i++) {
      productos.push({
        codigo: insertProduct[i][1],
        nombre: insertProduct[i][2],
        nombrecorto: insertProduct[i][2],
        ivacompra: insertProduct[i][5],
        ivaventa: insertProduct[i][9],
        exento: parseFloat(insertProduct[i][9]) > 0.0 ? false : true,
        valorfactor: insertProduct[i][3],
        tipofactor: parseInt(insertProduct[i][3]) > 1 ? 1 : 0,
        costoproveedor: insertProduct[i][6],
        costocalculado: insertProduct[i][6],
        ultimocosto: insertProduct[i][6],
        costopromedio: insertProduct[i][6],
        costoproveedoralter: insertProduct[i][4],
        costocalculadoalter: insertProduct[i][4],
        ultimocostoalter: insertProduct[i][4],
        costopromedioalter: insertProduct[i][4],
        utipreciomaxi: calcularUtilidadxValor(insertProduct[i]),
        utiprecioofe: calcularUtilidadxValor(insertProduct[i]),
        utipreciomayor: calcularUtilidadxValor(insertProduct[i]),
        utipreciomini: calcularUtilidadxValor(insertProduct[i]),
        utipreciomaxialter: calcularUtilidadxValorAlter(insertProduct[i]),
        utiprecioofealter: calcularUtilidadxValorAlter(insertProduct[i]),
        utipreciomayoralter: calcularUtilidadxValorAlter(insertProduct[i]),
        utipreciominialter: calcularUtilidadxValorAlter(insertProduct[i]),
      });
    }
    procesarRegistro(1, { productos: JSON.stringify(productos) });
  };

  const handleInputChange = (e) => {
    if (e.target.name === "file" && e.target.files.length > 0) {
      setActivate(true);
      setHeadCells([]);
      setInsertProduct([]);
      setUpdateProduct([]);
      let hojas = [];
      let reader = new FileReader();
      reader.readAsArrayBuffer(e.target.files[0]);
      reader.onload = (e) => {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array" });

        workbook.SheetNames.forEach(function (SheetName) {
          var objData = XLSX.utils.sheet_to_row_object_array(
            workbook.Sheets[SheetName]
          );

          hojas.push({
            data: objData,
            SheetName,
          });
        });

        let titulos = [];
        let produc = [];
        let titulo_sigue = false;
        let produc_sigue = false;
        let rueda = Object.keys(hojas[0].data[0]);

        try {
          for (let i = 0; i < rueda.length; i++) {
            titulos.push({
              label: rueda[i].toUpperCase(),
              textAlign: "center",
            });
          }
          titulo_sigue = true;
        } catch (error) {
          console.log(error);

          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: "el archivo xlsx esta mal formado",
            icono: "error",
          });
          setActivate(false);
        }

        try {
          for (let l = 0; l < hojas[0].data.length; l++) {
            console.log("pase" + l);
            let obj = {};
            let array = Object.values(hojas[0].data[l]);
            for (let k = 0; k < array.length; k++) {
              obj[k] = array[k];
            }
            produc.push(obj);
          }
          produc_sigue = true;
          setActivate(false);
        } catch (error) {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: "el archivo xlsx esta mal formado",
            icono: "error",
          });
          setActivate(false);
        }

        if (titulo_sigue === true && produc_sigue === true) {
          seleccionarRegistros(produc);
          setHeadCells(titulos);
        } else {
          setHeadCells([]);
          setInsertProduct([]);
          setUpdateProduct([]);
        }
      };
    }
  };

  const procesarPrecioProd = (cursorProduct, fileProduct) => {
    let element = fileProduct;
    const element0 = [];
    const viejos = [];
    let nuevos = [];

    for (let i = 0; i < fileProduct.length; i++) {
      for (let x = 0; x < cursorProduct.length; x++) {
        if (
          cursorProduct[x].toString().trim().toUpperCase() ===
          fileProduct[i][1].toString().trim().toUpperCase()
        ) {
          viejos.push(fileProduct[i][1]);
          element0.push(fileProduct[i]);
        }
      }
    }

    for (let i = 0; i < element.length; i++) {
      for (let x = 0; x < viejos.length; x++) {
        if (
          viejos[x].toString().trim().toUpperCase() ===
          element[i][1].toString().trim().toUpperCase()
        ) {
          element = element.filter(
            (value) =>
              value[1].toString().trim().toUpperCase() !==
              element[i][1].toString().trim().toUpperCase()
          );
        }
      }
    }
    nuevos = element;

    setInsertProduct(nuevos);
    setUpdateProduct(element0);
    setActivate(false);
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12" style={{ margin: 0 }}>
        <h1>PRODUCTOS POR ACTUALIZAR</h1>
        <div className="row col-md-12 py-2" style={{ margin: 0 }}>
          <div className="col-md-12 py-3 mx-auto card shadow ">
            <Dimmer active={activate} inverted>
              <Loader inverted>cargando...</Loader>
            </Dimmer>
            <div className="row col-md-12 mx-auto ">
              <div className="input-group input-group-sm mb-2 col-md-12 justify-content-between">
                <input
                  required
                  type="file"
                  name="file"
                  id="file"
                  className="form-control col-md-3"
                  onChange={handleInputChange}
                  placeholder="Ingrese Archivo Excel."
                />
              </div>
              {updateProduct.length > 0 && (
                <div className="col-md-6 mx-auto mb-3">
                  <div className="row col-md-12">
                    <button
                      type="button"
                      className="btn btn-warning btn-sm rounded-pill col-md-2 mb-3"
                      onClick={updateProcess}
                    >
                      {" "}
                      Actualizar
                    </button>
                  </div>

                  <TblContainer
                    container={{
                      height: 350,
                      width: "100%",
                      overflow: "auto",
                      padding: "2px",
                    }}
                  >
                    <TblHead />
                    <TableBody className="overflow-hidden">
                      {updateProduct &&
                        updateProduct.map((item, index) => (
                          <TableRow
                            key={index}
                            style={{
                              padding: "0",
                              backgroundColor: "transparent",
                            }}
                          >
                            {Object.values(item) &&
                              Object.values(item).map((item2, x) => (
                                <TableCell
                                  key={x}
                                  className="align-baseline p-0"
                                  style={{
                                    textAlign: "center",
                                    border: "solid 1px #000000",
                                  }}
                                >
                                  {item2}
                                </TableCell>
                              ))}
                          </TableRow>
                        ))}
                    </TableBody>
                  </TblContainer>
                </div>
              )}

              {insertProduct.length > 0 && (
                <div className="col-md-6 mx-auto mb-3">
                  <div className="row col-md-12">
                    <h1>PRODUCTOS POR REGISTRAR</h1>
                    <button
                      type="button"
                      className="btn btn-primary btn-sm rounded-pill col-md-2 mb-3"
                      onClick={insertProcess}
                    >
                      {" "}
                      Registrar
                    </button>
                  </div>

                  <TblContainer
                    container={{
                      height: 350,
                      width: "100%",
                      overflow: "auto",
                      padding: "2px",
                    }}
                  >
                    <TblHead />
                    <TableBody className="overflow-hidden">
                      {insertProduct &&
                        insertProduct.map((item, index) => (
                          <TableRow
                            key={index}
                            style={{
                              padding: "0",
                              backgroundColor: "transparent",
                            }}
                          >
                            {Object.values(item) &&
                              Object.values(item).map((item2, x) => (
                                <TableCell
                                  key={x}
                                  className="align-baseline p-0"
                                  style={{
                                    textAlign: "center",
                                    border: "solid 1px #000000",
                                  }}
                                >
                                  {item2}
                                </TableCell>
                              ))}
                          </TableRow>
                        ))}
                    </TableBody>
                  </TblContainer>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default IncluirProductosExcel;



// WEBPACK FOOTER //
// ./src/components/almacen/incluirProductosExcel.js